var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargeMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 2.66675H30.6666V9.33341H1.33325V2.66675Z",
    fill: "#CFF6E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 24.0001H30.6666V2.66675H1.33325V24.0001H5.33325",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 18.6667L16.7069 17.9596L15.9998 17.2525L15.2927 17.9596L15.9998 18.6667ZM20.6261 24.7072L21.3332 25.4143L22.7474 24.0001L22.0403 23.293L20.6261 24.7072ZM9.9594 23.293L9.25229 24.0001L10.6665 25.4143L11.3736 24.7072L9.9594 23.293ZM14.9998 18.6667L14.9998 30.6667L16.9998 30.6667L16.9998 18.6667L14.9998 18.6667ZM22.0403 23.293L16.7069 17.9596L15.2927 19.3739L20.6261 24.7072L22.0403 23.293ZM15.2927 17.9596L9.9594 23.293L11.3736 24.7072L16.7069 19.3739L15.2927 17.9596Z",
    fill: "#0FD08B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeMoney);
export default __webpack_public_path__ + "static/media/chargeMoney.7761471dc9dae0c01deb89ce4f4aec39.svg";
export { ForwardRef as ReactComponent };